'use client';

import ContentLoader from 'react-content-loader';

const PropertyListShimmer: React.FC = () => {
  return [...Array(9)].map((elementInArray, index) => (
    <div
      key={index}
      className="relative mx-auto w-full min-w-[290px] sm:min-w-[300px] max-w-none sm:max-w-[290px] rounded-lg overflow-hidden"
    >
      <ContentLoader
        speed={2}
        width="100%"
        height={260}
        viewBox="0 0 300 260"
        backgroundColor="#E6E6E6"
        foregroundColor="#f0f0f0"
        uniqueKey={`property-shimmer-${Math.random()}`}
        preserveAspectRatio="none"
        style={{
          width: '100%',
          height: '260px',
        }}
      >
        {/* Main image placeholder - use percentage for responsive */}
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="180" />

        {/* Price section - three items in a row using percentages */}
        <rect x="0" y="195" rx="4" ry="4" width="30%" height="14" />
        <rect x="35%" y="197" rx="4" ry="4" width="20%" height="10" />
        <rect x="60%" y="197" rx="4" ry="4" width="20%" height="10" />

        {/* Title */}
        <rect x="0" y="220" rx="4" ry="4" width="45%" height="10" />

        {/* Subtitle */}
        <rect x="0" y="240" rx="4" ry="4" width="40%" height="10" />
      </ContentLoader>
    </div>
  ));
};

export default PropertyListShimmer;
